import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";
import { isValidPercentageNumber } from "./admin-utils";

export const formatDeclineNetSalesPayload = ({
	declineGreaterThan,
	penalty
}) => {
	return {
		percentualQuedaGrupo: MonetaryUtils.parseDecimal(declineGreaterThan),
		percentualPenalidade: MonetaryUtils.parseDecimal(penalty)
	};
};

export const formatDeclineNetSalesResponse = declineNetSales => ({
	id: declineNetSales.id,
	declineGreaterThan: declineNetSales.percentualQuedaGrupo,
	penalty: declineNetSales.percentualPenalidade,
	createdAt: declineNetSales.dataCriacao,
	updatedAt: declineNetSales.dataUltimaAtualizacao
});

export const validateDeclineNetSalesPayload = values => {
    const errors = {};

    if (!hasValue(values.declineGreaterThan)) {
        errors.declineGreaterThan = "Informe o percentual de queda por grupo.";
    } else if (!isValidPercentageNumber(values.declineGreaterThan)) {
		errors.declineGreaterThan = "O percentual de queda grupo deve ter até 5 casas, sendo até 2 decimais.";
	}

    if (!hasValue(values.penalty)) {
        errors.penalty = "Informe a penalidade.";
	} else if (!isValidPercentageNumber(values.penalty)) {
		errors.penalty = "O percentual de penalidade deve ter até 5 casas, sendo até 2 decimais.";
    } else if (MonetaryUtils.parseDecimal(values.penalty) <= 0) {
        errors.penalty = "O percentual de penalidade deve ser maior que zero.";
    }

    return errors;
};